module.exports = __webpack_public_path__ + "65a5950cebbd049b2dea99c8d65089de.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/cutScale/excellent.png
// module id = 853
// module chunks = 0